import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

// components
import ErrorBoundary from 'layout/components/ErrorBoundary';
import PageShell from 'layout/components/PageShell';
import IntroCard from 'appExplainers/components/IntroCard';
import Privacy from 'appExplainers/components/Privacy';
import ButtonOpenTour from 'productTours/components/ButtonOpenTour';

// constants
import routesConfig from 'constants/routesConfig.json';

// styles
import { Files } from 'icons/untitledui';
import * as PageLayout from 'layout/styles/PageLayout.style';
import * as Buttons from 'theme/components/Buttons.style';
import * as Styled from 'appExplainers/styles/AboutPage.style';
import * as Text from 'theme/components/Text.style';

export default function AboutPage(): JSX.Element {
  const { t } = useTranslation('pageAbout');
  const history = useHistory();
  const appVersion = localStorage.getItem('app-version');
  const versionString = t('pageAbout.version', { version: appVersion });
  const onHelpClick = () => history.push(routesConfig.FAQ_PAGE);

  return (
    <ErrorBoundary>
      <PageLayout.Page>
        <PageShell title={t('pageAbout.header')} subtitle={versionString}>
          <IntroCard />

          <Styled.AboutSection style={{ marginBottom: '30px' }}>
            <Styled.ActionArea>
              <Buttons.SecondaryDark onClick={onHelpClick} small>
                <Files.FileQuestion02 />
                {t('intro.help')}
              </Buttons.SecondaryDark>
              <ButtonOpenTour />
            </Styled.ActionArea>
          </Styled.AboutSection>

          <Styled.AboutSection>
            <Text.H5>{t('privacy.subheader')}</Text.H5>
            <Privacy />
          </Styled.AboutSection>
        </PageShell>
      </PageLayout.Page>
    </ErrorBoundary>
  );
}
